import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { Target, Package, Megaphone, ShoppingCart, TrendingUp } from 'lucide-react';
export function ProgramOverview() {
  const features = [{
    icon: <Target className="w-6 h-6 text-cyan-400" data-id="element-189" />,
    text: 'Detectar una oportunidad real de mercado'
  }, {
    icon: <Package className="w-6 h-6 text-purple-400" data-id="element-190" />,
    text: 'Crear tu producto digital en días'
  }, {
    icon: <Megaphone className="w-6 h-6 text-pink-400" data-id="element-191" />,
    text: 'Construir una oferta clara e irresistible'
  }, {
    icon: <ShoppingCart className="w-6 h-6 text-green-400" data-id="element-192" />,
    text: 'Lanzar usando redes sociales como canal'
  }, {
    icon: <TrendingUp className="w-6 h-6 text-amber-400" data-id="element-193" />,
    text: 'Cerrar tus primeras ventas paso a paso'
  }];
  return <section className="py-20 px-4 bg-[#050510] relative overflow-hidden" data-id="element-194">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-purple-900/10 rounded-full blur-[120px]" data-id="element-195" />

      <div className="container mx-auto max-w-6xl relative z-10" data-id="element-196">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-197">
          <ScrollReveal direction="right" data-id="element-198">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-199">
              EL ARTE DE <br data-id="element-200" />
              <span className="text-gradient" data-id="element-201">
                MONETIZAR TUS REDES SOCIALES
              </span>
            </h2>
            <p className="text-xl text-gray-400 mb-8" data-id="element-202">
              Es un sistema práctico de 15 días diseñado para llevarte de cero a
              tu primera venta.
            </p>
            <div className="h-1 w-20 bg-cyan-500 rounded-full" data-id="element-203" />
          </ScrollReveal>

          <div className="space-y-4" data-id="element-204">
            {features.map((feature, index) => <ScrollReveal key={index} delay={index * 0.1} direction="left" width="100%" data-id="element-205">
                <div className="glass-card p-4 rounded-xl flex items-center gap-4 hover:bg-white/10 transition-colors duration-300" data-id="element-206">
                  <div className="bg-white/5 p-3 rounded-lg" data-id="element-207">
                    {feature.icon}
                  </div>
                  <span className="text-lg font-medium text-gray-200" data-id="element-208">
                    {feature.text}
                  </span>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </div>
    </section>;
}